import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../../core';
import { UsuarioFilter } from '../../filter';
import { usuarioPerfilGerente } from '../../usuario-perfil';
import { usuarioAtivo } from '../../usuario-situacao';
import { UsuarioCrudHttpService } from '../../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-usuario-gerente-multiselect',
    templateUrl: './usuario-gerente-multiselect.component.html',
    styleUrls: ['./usuario-gerente-multiselect.component.less']
})
export class UsuarioGerenteMultiselectComponent implements OnInit {
    /** Gerentes selecionados */
    @Input() idsGerentes: number[];
    /** Ao alterar a seleção dos gerentes */
    @Output() idsGerentesChange = new EventEmitter<number[]>();

    /** Se deve exibir somente os gerentes ativos */
    @Input() somenteAtivos = false;

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum Gerente';
    @Input() checked = 'Gerente';
    @Input() checkedPlural = 'Gerentes';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum gerente encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private usuarioCrudHttpService: UsuarioCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-gerente ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de bonificações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter = new UsuarioFilter();
        filter.perfil = usuarioPerfilGerente.id; // Gerentes
        // Somente Ativos
        if (this.somenteAtivos) {
            filter.situacao = usuarioAtivo.id;
        }

        this.usuarioCrudHttpService.searchWithFilter(filter, null, null, null, null, null)
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    if (response && response.data) {
                        response.data.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar os gerentes', error);
                }
            );
    }

    /** Ao alterar a seleção dos gerentes */
    onChange() {
        this.idsGerentesChange.emit(this.idsGerentes);
    }
}
